import * as moment from 'moment';
import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { DayEntryModel, UserModel } from '../../../models/models';
import { ConfigurationProvider, DayEntryProvider, SupplementStackProvider, UserProvider } from '../../../providers/providers';

@Component({
  selector: 'page-dashboard-log-supplement',
  templateUrl: 'dashboard-log-supplement.html'
})
export class DashboardLogSupplementPage {
  dayEntry: DayEntryModel;
  deleteItems: number[] = [];
  entryTime: moment.Moment = moment();
  searchList: any[] = [];
  searchListAll: any[] = [];
  user: UserModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private params: NavParams,
    private stackProvider: SupplementStackProvider,
    private userProvider: UserProvider,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      date: item ? item.Date : null
    });
  }

  doGetItems(ev: any) {
    // Reset items back to all of the items
    this.searchListAll = [];
    
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.searchListAll = this.searchList.filter((item) => {
        return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  doRemove(item: any) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            if (item.DayEntrySupplementId) {
              this.deleteItems.push(item.DayEntrySupplementId);
            }
            this.dayEntry.Supplements = this.dayEntry.Supplements.filter((m: any) => m !== item);
          }
        }
      ]
    });
    confirm.present();
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete items, if any
      if (this.deleteItems.length > 0) {
        this.dayEntryProvider.DeleteSupplementItems(this.deleteItems);
      }

      // save day entry food items
      this.dayEntryProvider.SaveSupplements(this.user, this.dayEntry).then((res: DayEntryModel) => {

        // if day entry is today, update the user's body weight
        if (moment(this.dayEntry.Date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && this.dayEntry.BodyComposition.Weight !== this.user.BodyWeight) {
          this.userProvider.SaveBodyWeight(this.user._id, this.dayEntry.BodyComposition.Weight);
        }

        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res);
      });
    }
  }

  doSelectItem(item: any) {
    let inputs = [
      {
        name: 'time',
        type: 'time',
        placeholder: 'Time',
        value: moment(this.entryTime).format('HH:mm')
      }
    ];

    if (!item.IsStack) {
      inputs.push({
        name: 'serving',
        type: 'serving',
        placeholder: 'Servings',
        value: '1'
      });
      inputs.push({
        name: 'start_date',
        type: 'date',
        placeholder: 'Start Date',
        value: moment(item.StartDate).format('YYYY-MM-DD')
      });
    }

    const prompt = this.alertCtrl.create({
      title: 'Log Supplement',
      message: item.Name,
      inputs: inputs,
      buttons: [
        {
          text: 'Cancel'
        },
        {
          text: 'Add',
          handler: data => {
            item.Time = data.time;
            this.entryTime = moment(item.Time, 'HH:mm');

            if (!item.IsStack) {
              item.StartDate = data.start_date;
              item.Serving = data.serving;
              if (this.dayEntry.Supplements.find((x: any) => {
                return x === item;
              }) === undefined) {
                this.dayEntry.Supplements.push(item);
              }
            }
            else {
              // load stack
              this.stackProvider.LoadSupplementItems(item.StackId).then((supps: any[]) => {
                supps.forEach(supp => {
                  this.dayEntry.Supplements.push({
                    IsStack: true,
                    StackId: item.StackId,
                    SupplementId: supp.SupplementId,
                    Time: item.Time,
                    StackName: item.Name,
                    Name: supp.Name,
                    Brand: supp.Brand,
                    Portion: supp.Portion,
                    Serving: supp.Serving,
                    StartDate: supp.StartDate,
                    icon: "arrow-dropdown",
                    showDetails: false
                  } as any);
                });
              });
            }
          }
        }
      ]
    });
    prompt.present();
  }

  formIsValid() {
    if (!this.dayEntry.Supplements) {
      this.config.showAlert('Error', 'Must search for and select at least one supplement.');
      return false;
    }

    return true;
  }

  ionViewWillLoad() {
    this.dayEntry = this.params.get('dayEntry');
    this.user = this.params.get('user');

    this.loadView();
  }

  loadView() {
    this.config.showLoading();

    this.dayEntryProvider.LoadSupplementSearch().then((items: any[]) => {
      this.searchList = items;

      // load food items for this day entry, if any
      this.dayEntryProvider.LoadSupplements(this.user._id, this.dayEntry).then((dayEntry: any) => {
        this.dayEntry = dayEntry;
        this.config.dismissLoading();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/nutrition/dashboard-log-supplement.ts